import { QueryClient } from '@tanstack/react-query';

import { isApiError } from './errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /*
       * A 4xx is a settled answer — a bad id, a missing permission, a stubbed
       * route. Retrying it only delays the error the user needs to see. 5xx and
       * network failures are the transient ones worth a second attempt.
       */
      retry: (failureCount, error) =>
        isApiError(error) && error.status < 500 ? false : failureCount < 2,
      /*
       * Shorter than the admin panel's 30s. This app is read by someone
       * standing at a counter while stock moves under them — two staff on two
       * tablets selling from the same shelf is the normal case, so a stale
       * quantity here has a customer waiting behind it.
       */
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});
